t = require('views/internal/teacup-with-helpers')('header_overdue_banner')

module.exports = ->
  t.p '.u-bottom', ->
    t.format 'the-billing-information-for-team-is-out-of-date', { team: t.mustacheVar('team') }
    t.a '.header-banner-link-left.quiet.js-update-billing-information', { href: t.mustacheVar('billingUrl') }, ->
      t.format 'update-billing-information'
    t.a '.header-banner-link-left.quiet.js-dismiss-overdue-banner', { href: "#", style: 'float: right' }, ->
      t.icon 'close'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_overdue_banner.coffee